import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getCodeDetails({ payload: { id, onSuccess } }) {

  try {
    const { data } = yield call(fetch, { api: api.codes.get, id });

    onSuccess && onSuccess(data.result);
    yield put(actions.getCodeDetailsDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCodeDetailsFailed,
      endpoint: api.codes.get.url
    });
  }
}

export const getCodeDetailsSaga = takeEvery(types.GET_CODE_DETAILS_REQUEST, getCodeDetails);